/* eslint-disable @typescript-eslint/no-explicit-any */
import { accountService } from '@/api/services/account-service'
import { lectureService } from '@/api/services/lecture-service'
import { useAuthStore } from '@/stores/auth'
import type { LectureOrder } from '@/types/lecture.types'
import { Bootpay } from '@bootpay/client-js'

async function requestPayment(order: LectureOrder) {
  let isSuccess = false
  const authStore = useAuthStore()

  try {
    const response = await Bootpay.requestPayment({
      "application_id": import.meta.env.VITE_BOOTPAY_JAVASCRIPT_KEY,
      "price": order.price,
      "order_name": order.orderName,
      "order_id": order.orderId.toString(),
      "tax_free": 0,
      "user": {
        "id": authStore.state.account?.idx.toString(),
        "username": authStore.state.account?.nickname,
        "email": authStore.state.account?.email
      },
      "extra": {
        "open_type": "iframe",
        "card_quota": "0",
        "escrow": false,
        "separately_confirmed": true,
      }
    })

    if (response.event === 'confirm') {
      console.log(response)
      await lectureService.requestApprovalPayment(response.receipt_id)
      isSuccess = true
    }
  } catch (e: any) {
    console.error(e.message)
    isSuccess = false
  } finally {
    Bootpay.destroy()

    return isSuccess
  }
}

async function requestAuthentication() {
  let isSuccess = false
  const authStore = useAuthStore()
  const timestamp = new Date().getTime()
  const userId = authStore.state.account?.idx || 'guest'
  const authenticationId = `${userId}_${timestamp}`

  try {
    const response = await Bootpay.requestAuthentication({
      application_id: import.meta.env.VITE_BOOTPAY_JAVASCRIPT_KEY,
      pg: 'KCP',
      order_name: '본인인증',
      authentication_id: authenticationId,
      extra: {
        open_type: 'iframe',
        show_close_button: true,
      }
    })

    switch (response.event) {
      case 'done':
        // 본인인증 완료, 본인인증의 경우 성공시 done 이벤트만 받는다 (만약 분리승인 옵션을 줬을 경우 confirm 도 수신하게 됨)
        console.log(response.data)
        await accountService.selfAuthentication(response.data.receipt_id)
        // 결제 완료 처리
        isSuccess = true
        break
    }
  } catch (e: any) {
    // 결제 진행중 오류 발생
    // e.error_code - 부트페이 오류 코드
    // e.pg_error_code - PG 오류 코드
    // e.message - 오류 내용
    console.log(e.message)
    switch (e.event) {
      case 'cancel':
        // 사용자가 결제창을 닫을때 호출
        console.log(e.message);
        break
      case 'error':
        // 결제 승인 중 오류 발생시 호출
        console.log(e.error_code);
        break
    }
    isSuccess = false
  } finally {
    Bootpay.destroy()

    return isSuccess
  }
}

export { requestAuthentication, requestPayment }
